import React, { memo, useMemo, useSyncExternalStore } from 'react';
import TimelineSpeaker from './TimelineSpeaker';
import { getScreenShareSpeakerDetails, getSharedVideoTrackDetails } from '../utils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { CompositeSegment } from '@/App/remotion/MainPlayer/types/Segment/CompositeSegment';
import { useTimelineSpeakers } from '@/hooks/useTimelineSpeakers';
import { speakersAnalysisStore } from '@/stores/speakersAnalysis/speakersAnalysis';

function TimelineSpeakers({
  compositeSegmentDragStart,
  compositeSegmentDragEnd,
  compositeSegment
}: {
  compositeSegmentDragStart: number;
  compositeSegmentDragEnd: number;
  compositeSegment: CompositeSegment;
}) {
  const { clipData, fps } = useClipsContext();

  const { speakers, recordings } = useTimelineSpeakers();

  const speakersAnalysisForAllClips = useSyncExternalStore(
    speakersAnalysisStore.subscribe,
    speakersAnalysisStore.getSnapshot
  );

  const screenShareSpeakerDetails = useMemo(
    () => getScreenShareSpeakerDetails(recordings, clipData, speakersAnalysisForAllClips),
    [recordings, clipData, speakersAnalysisForAllClips]
  );

  const sharedVideoTrackDetails = useMemo(() => getSharedVideoTrackDetails(recordings), [recordings]);

  return (
    <div className="flex flex-col gap-1">
      {speakers.map(speaker => (
        <TimelineSpeaker
          key={speaker.key}
          speaker={speaker}
          speakerCount={speakers.length}
          compositeSegmentDragStart={compositeSegmentDragStart}
          compositeSegmentDragEnd={compositeSegmentDragEnd}
          compositeSegment={compositeSegment}
          fps={fps}
        />
      ))}
      {screenShareSpeakerDetails && (
        <TimelineSpeaker
          key={screenShareSpeakerDetails.id}
          speaker={screenShareSpeakerDetails}
          speakerCount={speakers.length}
          compositeSegmentDragStart={compositeSegmentDragStart}
          compositeSegmentDragEnd={compositeSegmentDragEnd}
          compositeSegment={compositeSegment}
          fps={fps}
        />
      )}
      {sharedVideoTrackDetails && (
        <TimelineSpeaker
          key={sharedVideoTrackDetails.id}
          speaker={sharedVideoTrackDetails}
          speakerCount={speakers.length}
          compositeSegmentDragStart={compositeSegmentDragStart}
          compositeSegmentDragEnd={compositeSegmentDragEnd}
          compositeSegment={compositeSegment}
          fps={fps}
        />
      )}
    </div>
  );
}

export default memo(TimelineSpeakers);
